<template>
  <div class="chart-wrap">
    <div
      v-if="hasReportData"
      data-qa-id="line-chart-component"
      class="chart"
    >
      <Linechart
        :is-earning-report="isEarningReport"
        :datas="lineChartData?.yAxis"
        :labels="lineChartData?.xAxis"
      />
    </div>
    <div
      v-else
      class="no-chart-data"
    >
    <div class="no-chart-data__message">
        <div class="no-chart-data__message__title">
          {{ $t(`pages.dashboard.components.report.empty_data.title`, { reportLabel }) }}
        </div>
        <div class="no-chart-data__message__para">
          {{ $t(`pages.dashboard.components.report.empty_data.desc`, { reportLabel }) }}
          <a
            class="no-chart-link"
            :href="emptyReportUrl"
            target="_blank"
          >
            {{ $t(`pages.dashboard.components.report.empty_data.btn`) }}
          </a>
        </div>
      </div>
      <img
        class="empty-graph"
        src="../../../../../../assets/images/Graph.svg"
        alt="empty-graph"
      >
    </div>
    <div
      class="chart-data"
      data-qa-id="line-chart-data"
    >
      <div v-if="hasReportData" class="chart-data__total-earnings">
        <div class="chart-data__total-earnings__title">
          {{ $t(`pages.dashboard.components.report.${earningGraphMetaData?.label}`) }}
        </div>
        <div
          data-qa-id="earning-total"
          class="chart-data__total-earnings__value"
        >
          <span>
            {{ earningGraphMetaData.total }}
          </span>
        </div>
      </div>
      <div
        v-if="!hasReportData"
        class="no-earning-info"
      >
        <span class="bulb-icon" />
        <p class="no-earning-info__para">
          <a
            class="no-earning-info__para__link"
            :href="foundrySupportUrl"
            target="_blank"
          > {{ $t(`pages.dashboard.components.report.empty_data.learn_more`) }} </a> {{ $t(`pages.dashboard.components.report.empty_data.learn_more_desc`) }}
        </p>
      </div>
      <div
        v-if="hasReportData"
        class="chart-grid"
      >
        <div
          v-for="topData in earningGraphMetaData.topData"
          :key="topData.labels"
          :data-qa-id="`data-${topData.label}`"
        >
          <div
            :data-qa-id="`data-title-${topData.label}`"
            class="chart-grid__title"
          >
            {{ $t(`pages.dashboard.components.report.${topData.label}`) }}
          </div>
          <div
            v-if="topData.data"
            :data-qa-id="`data-other-${topData.label}`"
            class="chart-grid__text"
          >
            {{ topData.data }}
          </div>
          <div
            :data-qa-id="`data-amount-${topData.label}`"
            class="chart-grid__text"
          >
            {{ topData.value }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="hasReportData && isEarningReport"
      class="chart-actions"
    >
      <md-button class="view_report" data-qa-id="btn-goto-report" @click="gotoReport()">
        <MdIconReports class="view_report_icon" rotate="up" size="small" icontitle="enabled" slot="icon-start"></MdIconReports>
        {{ $t('pages.dashboard.components.report.view_report') }}
      </md-button>
    </div>
  </div>
</template>
<script src="./script.js"></script>
<style lang="scss" src="./stylesheets/index.scss" />
